import React from 'react';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import TimeFormat from '@/components/TimeFormat';

function Time({ elapsed, total }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <Typography variant={isMobile ? "h4" : "h1"}>
      <TimeFormat time={total - elapsed} />
    </Typography>
  )
}

export default Time;
